import script from "./IpOSAdminDash.vue?vue&type=script&setup=true&lang=js"
export * from "./IpOSAdminDash.vue?vue&type=script&setup=true&lang=js"

import "./IpOSAdminDash.vue?vue&type=style&index=0&id=35ffbdba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ffbdba"]])

export default __exports__